// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '1cc917cb-cc26-48a8-95d2-a712c80924b6',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '01084392-b858-41ec-bd78-155a20379278',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: 0,
      y: 11,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 125,
      height: 53,
      leftWidth: 28,
      topHeight: 0,
      rightWidth: 28,
      bottomHeight: 0,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Top_UI_Amount_Background_9Slice_28x0x28x0',
      parent: '1cc917cb-cc26-48a8-95d2-a712c80924b6'
    },
    {
      id: '1cde354e-8d5b-464a-bc63-a87f193476ae',
      type: 'Sprite',
      name: 'icon',
      className: '',
      x: 22,
      y: 39,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.6,
        y: 1.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Small_Plank_Icon',
      parent: '1cc917cb-cc26-48a8-95d2-a712c80924b6'
    },
    {
      id: 'b13899a6-916f-4af8-ada6-453e3f3d32d7',
      type: 'Text',
      name: 'countText',
      className: '',
      x: 85,
      y: 42,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x5',
      localize: false,
      maxWidth: 100,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '0x3A0B03',
        strokeThickness: 6,
        align: 'right',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '1cc917cb-cc26-48a8-95d2-a712c80924b6',
      data: {
        template: '#'
      }
    },
    {
      id: '49017161-416e-42a5-b735-f9c2b92d398d',
      type: 'Sprite',
      name: 'check',
      className: '',
      x: 87,
      y: 43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Goal_Check_Icon',
      parent: '1cc917cb-cc26-48a8-95d2-a712c80924b6'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class BasicTaskLayout {
  static raw = raw;
  root!: Container;
  icon!: Sprite;
  countText!: Text & { data: typeof raw['list'][4]['data'] };
  check!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
